<template>
  <div>
    <v-dialog
      v-model="data.dialogShow"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="elevation-1 green lighten-2">
          <v-btn flat icon @click="data.dialogShow = false">
            <font-awesome-icon
              icon="arrow-left"
              size="2x"
              class="black--text"
            />
          </v-btn>

          <v-spacer></v-spacer>
          <v-toolbar-items></v-toolbar-items>
        </v-toolbar>

        <v-container fluid>
          <v-card class="mb-3 py-3 elevation-1 green lighten-5">
            <v-layout align-start justify-start row wrap class="mb-3">
              <v-flex md6>
                <v-layout align-start justify-start row wrap>
                  <v-flex md3 class="px-3 subHeading font-weight-medium"
                    >Username</v-flex
                  >
                  <v-flex
                    md9
                    class="
                      px-3
                      subHeading
                      font-weight-medium
                      green--text
                      darken-4
                    "
                    >: {{ item_data.user_name }}</v-flex
                  >
                </v-layout>
                <v-layout align-start justify-start row wrap>
                  <v-flex md3 class="px-3 subHeading font-weight-medium"
                    >Nama</v-flex
                  >
                  <v-flex
                    md9
                    class="
                      px-3
                      subHeading
                      font-weight-medium
                      green--text
                      darken-4
                    "
                    >: {{ item_data.nama }}</v-flex
                  >
                </v-layout>

                <v-layout align-start justify-start row wrap>
                  <v-flex md3 class="px-3 subHeading font-weight-medium"
                    >Tanggal Lahir</v-flex
                  >
                  <v-flex
                    md9
                    class="
                      px-3
                      subHeading
                      font-weight-medium
                      green--text
                      darken-4
                    "
                    >: {{ item_data.tanggal_lahir | date }}</v-flex
                  >
                </v-layout>
                <v-layout align-start justify-start row wrap>
                  <v-flex md3 class="px-3 subHeading font-weight-medium"
                    >Sudah Modifikasi</v-flex
                  >
                  <v-flex
                    md9
                    class="
                      px-3
                      subHeading
                      font-weight-medium
                      green--text
                      darken-4
                    "
                    >: {{ item_data.is_modified }}</v-flex
                  >
                </v-layout>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout>
              <v-flex md5>
                <table>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      IQ RAW TOTAL
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.iq_total | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">IQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.iq_total_iq | numberN0 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">EQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.eq_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium"></td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    ></td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">Sc.Q</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.scq_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium"></td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    ></td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">KB RAW</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kb_raw | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">KB IQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kb_iq | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Persen</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kb_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Ket</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kb_keterangan }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Rank</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kb_rank | numberN0 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">LM RAW</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.lm_raw | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">LM IQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.lm_iq | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Persen</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.lm_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Ket</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.lm_keterangan }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Rank</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.lm_rank | numberN0 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">KS RAW</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ks_raw | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">KS IQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ks_iq | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Persen</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ks_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Ket</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ks_keterangan }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Rank</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ks_rank | numberN0 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">KM RAW</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.km_raw | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">KM IQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.km_iq | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Persen</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.km_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Ket</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.km_keterangan }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Rank</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.km_rank | numberN0 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">KK RAW</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kk_raw | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">KK IQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kk_iq | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Persen</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kk_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Ket</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kk_keterangan }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Rank</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kk_rank | numberN0 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">KI RAW</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ki_raw | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">KI IQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ki_iq | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Persen</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ki_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Ket</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ki_keterangan }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Rank</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ki_rank | numberN0 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">KA RAW</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ka_raw | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">KA IQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ka_iq | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Persen</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ka_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Ket</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ka_keterangan }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Rank</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.ka_rank | numberN0 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">KN RAW</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kn_raw | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">KN IQ</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kn_iq | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Persen</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kn_persen | numberN0 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Ket</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kn_keterangan }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">Rank</td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.kn_rank | numberN0 }}
                    </td>
                  </tr>
                </table>
              </v-flex>
              <v-flex md5>
                <table>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      CITA - CITA 1
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.cita_cita_1 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">
                      Minat Pekerjaan 1
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.minat_pekerjaan_1 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      CITA - CITA 2
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.cita_cita_2 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">
                      Minat Pekerjaan 2
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.minat_pekerjaan_2 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      CITA - CITA 3
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.cita_cita_3 }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">
                      Minat Pekerjaan 3
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.minat_pekerjaan_3 }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ fakultas_1_label }}
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.studi_lanjutan_1_fakultas }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ fakultas_1_prodi_label }}
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.studi_lanjutan_1_prodi }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ fakultas_2_label }}
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.studi_lanjutan_2_fakultas }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ fakultas_2_prodi_label }}
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.studi_lanjutan_2_prodi }}
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ kesimpulan_tambahan_label }}
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      : {{ item_data.studi_lanjutan_kedinasan }}
                    </td>
                    <td class="px-3 subHeading font-weight-medium"></td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    ></td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      KESIMPULAN :
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    ></td>
                    <td class="px-3 subHeading font-weight-medium"></td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    ></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="px-3 subHeading font-weight-medium">
                      {{ item_data.kesimpulan }}
                    </td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card class="mb-3 py-3 elevation-1 green lighten-5">
            <v-layout>
              <v-flex md6>
                <table>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ fakultas_1_label }}
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      <v-text-field
                        v-model="fakultas_1"
                        single-line
                      ></v-text-field>
                    </td>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ fakultas_1_prodi_label }}
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      <v-text-field
                        v-if="isShowProdi"
                        v-model="fakultas_1_prodi"
                        single-line
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ fakultas_2_label }}
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      <v-text-field
                        v-model="fakultas_2"
                        single-line
                      ></v-text-field>
                    </td>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ fakultas_2_prodi_label }}
                    </td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      <v-text-field
                        v-if="isShowProdi"
                        v-model="fakultas_2_prodi"
                        single-line
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium">
                      {{ kesimpulan_tambahan_label }}
                    </td>
                    <td
                      colspan="3"
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      <v-textarea v-model="kesimpulan_tambahan"></v-textarea>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 subHeading font-weight-medium"></td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    >
                      <v-btn
                        :loading="is_loading"
                        color="light-blue darken-3"
                        class="elevation-1"
                        @click="inputSaran_OnSave()"
                      >
                        <v-icon class="pr-2">save</v-icon>SAVE
                      </v-btn>
                      <v-btn
                        :loading="is_loading"
                        color="red darken-1"
                        class="elevation-1"
                        @click="data.dialogShow = false"
                      >
                        <v-icon class="pr-2">close</v-icon>Cancel
                      </v-btn>
                    </td>
                    <td class="px-3 subHeading font-weight-medium"></td>
                    <td
                      class="
                        px-2
                        subHeading
                        font-weight-medium
                        green--text
                        darken-4
                      "
                    ></td>
                  </tr>
                </table>
              </v-flex>
              <v-flex md6>
                <v-layout>
                  <span style="width: 50px">
                    <v-text-field
                      v-model="km_new_kb"
                      single-line
                      persistent-hint
                      hint="KB"
                      label="KB"
                    ></v-text-field>
                  </span>
                  <span class="ml-4" style="width: 50px">
                    <v-text-field
                      v-model="km_new_lm"
                      single-line
                      persistent-hint
                      hint="LM"
                      label="LM"
                    ></v-text-field>
                  </span>
                  <span class="ml-4" style="width: 50px">
                    <v-text-field
                      v-model="km_new_ks"
                      single-line
                      persistent-hint
                      hint="KS"
                      label="KS"
                    ></v-text-field>
                  </span>
                  <span class="ml-4" style="width: 50px">
                    <v-text-field
                      v-model="km_new_km"
                      single-line
                      persistent-hint
                      hint="KM"
                      label="KM"
                    ></v-text-field>
                  </span>
                  <span class="ml-4" style="width: 50px">
                    <v-text-field
                      v-model="km_new_kk"
                      single-line
                      persistent-hint
                      hint="KK"
                      label="KK"
                    ></v-text-field>
                  </span>
                  <span class="ml-4" style="width: 50px">
                    <v-text-field
                      v-model="km_new_ki"
                      single-line
                      persistent-hint
                      hint="KI"
                      label="KI"
                    ></v-text-field>
                  </span>
                  <span class="ml-4" style="width: 50px">
                    <v-text-field
                      v-model="km_new_ka"
                      single-line
                      persistent-hint
                      hint="KA"
                      label="KA"
                    ></v-text-field>
                  </span>
                  <span class="ml-4" style="width: 50px">
                    <v-text-field
                      v-model="km_new_kn"
                      single-line
                      persistent-hint
                      hint="KN"
                      label="KN"
                    ></v-text-field>
                  </span>
                  <v-btn
                    :loading="is_loading"
                    color="orange lighten-4-"
                    class="elevation-1"
                    @click="updateKm_preview()"
                  >
                    <v-icon class="pr-2">preview</v-icon>PREVIEW
                  </v-btn>

                  <v-btn
                    :loading="is_loading"
                    color="light-blue darken-3"
                    class="elevation-1"
                    @click="updateKm_OnSave()"
                  >
                    <v-icon class="pr-2">save</v-icon>SIMPAN
                  </v-btn>
                  <v-btn
                    :loading="is_loading"
                    color="red darken-1"
                    class="elevation-1"
                    @click="updateKm_OnReset()"
                  >
                    <v-icon class="pr-2">close</v-icon>RESET
                  </v-btn>
                </v-layout>
                <v-layout>
                  <v-flex md12 class="mt-3">
                    <table>
                      <tr>
                        <td class="px-3 subHeading font-weight-medium">
                          IQ RAW TOTAL
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.iq_total | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">IQ</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.iq_iq | numberN0 }}
                        </td>
                      </tr>

                      <tr>
                        <td class="px-3 subHeading font-weight-medium">
                          KB RAW
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kb_raw | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          KB IQ
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kb_iq | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          Persen
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kb_persen | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Ket</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kb_keterangan }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Rank</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kb_rank | numberN0 }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-3 subHeading font-weight-medium">
                          LM RAW
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.lm_raw | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          LM IQ
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.lm_iq | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          Persen
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.lm_persen | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Ket</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.lm_keterangan }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Rank</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.lm_rank | numberN0 }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-3 subHeading font-weight-medium">
                          KS RAW
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ks_raw | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          KS IQ
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ks_iq | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          Persen
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ks_persen | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Ket</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ks_keterangan }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Rank</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ks_rank | numberN0 }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-3 subHeading font-weight-medium">
                          KM RAW
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.km_raw | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          KM IQ
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.km_iq | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          Persen
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.km_persen | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Ket</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.km_keterangan }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Rank</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.km_rank | numberN0 }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-3 subHeading font-weight-medium">
                          KK RAW
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kk_raw | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          KK IQ
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kk_iq | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          Persen
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kk_persen | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Ket</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kk_keterangan }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Rank</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kk_rank | numberN0 }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-3 subHeading font-weight-medium">
                          KI RAW
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ki_raw | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          KI IQ
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ki_iq | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          Persen
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ki_persen | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Ket</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ki_keterangan }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Rank</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ki_rank | numberN0 }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-3 subHeading font-weight-medium">
                          KA RAW
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ka_raw | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          KA IQ
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ka_iq | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          Persen
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ka_persen | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Ket</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ka_keterangan }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Rank</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.ka_rank | numberN0 }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-3 subHeading font-weight-medium">
                          KN RAW
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kn_raw | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          KN IQ
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kn_iq | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">
                          Persen
                        </td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kn_persen | numberN0 }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Ket</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kn_keterangan }}
                        </td>
                        <td class="px-3 subHeading font-weight-medium">Rank</td>
                        <td
                          class="
                            px-2
                            subHeading
                            font-weight-medium
                            green--text
                            darken-4
                          "
                        >
                          : {{ data_km_preview.kn_rank | numberN0 }}
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { format } from "date-fns";
import numeral from "numeral";

export default {
  props: {
    data: Object,
  },
  data: () => ({
    detail_loading: false,
    fakultas_1_label: "Fakultas 1 :",
    fakultas_1: "",
    fakultas_1_prodi_label: "Prodi :",
    fakultas_1_prodi: "",
    fakultas_2_label: "Fakultas 2 :",
    fakultas_2: "",
    fakultas_2_prodi_label: "Prodi :",
    fakultas_2_prodi: "",
    item_data: "",
    is_loading: false,
    kesimpulan_tambahan_label: "Tambahan Kesimpulan :",
    kesimpulan_tambahan: "",
    km_new_kb: "",
    km_new_lm: "",
    km_new_ks: "",
    km_new_km: "",
    km_new_kk: "",
    km_new_ki: "",
    km_new_ka: "",
    km_new_kn: "",
    data_km_preview: "",
  }),
  filters: {
    date: function (value) {
      return format(new Date(value), "DD-MM-YYYY");
    },
    number: function (value) {
      return numeral(value).format("0,0.00");
    },
    numberN3: function (value) {
      return numeral(value).format("0,0.000");
    },
    numberN0: function (value) {
      return numeral(value).format("0,0");
    },
  },
  computed: {
    isShowProdi: function () {
      return  true; //this.item_data.tingkat_pendidikan !== "X";
    },
  },

  methods: {
    updateKm_OnReset: function () {
      const vm = this;
      vm.is_loading = true;

      ApiService.post("dashboard/UpdateKm_OnReset", {
        exercise_id: vm.item_data.exercise_id,
      })
        .then(() => {
          vm.is_loading = false;
          vm.init(vm.item_data);
        })
        .catch(() => {})
        .finally(() => {
          vm.is_loading = false;
        });
    },
    updateKm_OnSave: function () {
      const vm = this;
      vm.is_loading = true;

      ApiService.post("dashboard/UpdateKm_OnSave", {
        exercise_id: vm.item_data.exercise_id,
        data_update: vm.data_km_preview,
      })
        .then(() => {
          vm.is_loading = false;
          vm.init(vm.item_data);
          //vm.data_km_preview = response.data.result.value;
        })
        .catch(() => {})
        .finally(() => {
          vm.is_loading = false;
        });
    },
    updateKm_preview: function () {
      const vm = this;
      vm.is_loading = true;

      ApiService.post("exercise/UpdateKm_Preview", {
        exercise_id: vm.item_data.exercise_id,
        row_kb: vm.km_new_kb,
        row_lm: vm.km_new_lm,
        row_ks: vm.km_new_ks,
        row_km: vm.km_new_km,
        row_kk: vm.km_new_kk,
        row_ki: vm.km_new_ki,
        row_ka: vm.km_new_ka,
        row_kn: vm.km_new_kn,
      })
        .then((response) => {
          vm.data_km_preview = response.data.result.value;
        })
        .catch(() => {})
        .finally(() => {
          vm.is_loading = false;
        });
    },
    inputSaran_OnSave: function () {
      const vm = this;

      vm.is_loading = true;

      ApiService.post("Dashboard/DashboardInputSaran_OnSave", {
        exercise_id: vm.item_data.exercise_id,
        saran_fakultas_1: vm.fakultas_1,
        saran_fakultas_1_prodi: vm.fakultas_1_prodi,
        saran_fakultas_2: vm.fakultas_2,
        saran_fakultas_2_prodi: vm.fakultas_2_prodi,
        kesimpulan_tambahan: vm.kesimpulan_tambahan,
      })
        .then(() => {
          vm.is_loading = false;
        })
        .catch(() => {})
        .finally(() => {
          vm.is_loading = false;
        });
    },
    init: function (param) {
      this.detail_loading = false;
      this.fakultas_1_label = "Fakultas 1 :";
      this.fakultas_1 = "";
      this.fakultas_1_prodi_label = "Prodi :";
      this.fakultas_1_prodi = "";
      this.fakultas_2_label = "Fakultas 2 :";
      this.fakultas_2 = "";
      this.fakultas_2_prodi_label = "Prodi :";
      this.fakultas_2_prodi = "";
      this.item_data = "";
      this.is_loading = false;
      this.kesimpulan_tambahan_label = "Tambahan Kesimpulan :";
      this.kesimpulan_tambahan = "";
      this.km_new_kb = "";
      this.km_new_lm = "";
      this.km_new_ks = "";
      this.km_new_km = "";
      this.km_new_kk = "";
      this.km_new_ki = "";
      this.km_new_ka = "";
      this.km_new_kn = "";
      this.data_km_preview = "";

      const vm = this;
      vm.data.detail_loading = true;
      // Clear Data

      ApiService.post("Dashboard/DashboardInputSaran_Init", {
        user_id: param.user_id,
        exercise_id: param.exercise_id,
      })
        .then((response) => {
          vm.item_data = response.data;
          vm.fakultas_1 = response.data.saran_fakultas_1;
          vm.fakultas_1_prodi = response.data.saran_fakultas_1_prodi;
          vm.fakultas_2 = response.data.saran_fakultas_2;
          vm.fakultas_2_prodi = response.data.saran_fakultas_2_prodi;
          vm.kesimpulan_tambahan = response.data.kesimpulan_tambahan;
          vm.km_new_kb = "";
          vm.km_new_lm = "";
          vm.km_new_ks = "";
          vm.km_new_km = "";
          vm.km_new_kk = "";
          vm.km_new_ki = "";
          vm.km_new_ka = "";
          vm.km_new_kn = "";
          vm.data_km_preview = "";

          if (response.data.tingkat_pendidikan === "IX") {
            vm.fakultas_1_label = "Studi 1 :";
            vm.fakultas_1_prodi_label = "Jurusan";
            vm.fakultas_2_label = "Studi 2:";
            vm.fakultas_2_prodi_label = "Jurusan";
          }

          // if (response.data.tingkat_pendidikan === "X") {
          //   vm.fakultas_1_label = "Disarankan :";
          //   vm.fakultas_1_prodi_label = "";
          //   vm.fakultas_2_label = "Tidak Disarankan :";
          //   vm.fakultas_2_prodi_label = "";
          //   vm.kesimpulan_tambahan_label =
          //     "Kurang disarankanTidak disarankan :";
          // }
        })
        .catch(() => {})
        .finally(() => {
          vm.data.detail_loading = false;
          vm.data.dialogShow = true;
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
.table-header /deep/ {
  thead {
    background-color: black;
  }
}

.media-menu {
  min-width: 260px;
  border-right: 1px solid #eee;
  min-height: calc(100vh - 50px - 64px);
}

.media-detail {
  min-width: 300px;
  border-left: 1px solid #eee;
}
</style>
